
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.824.18a.591.591 0 00-.848 0L3.787 7.52 1.024 4.7a.591.591 0 00-.848 0 .622.622 0 000 .867L3.363 8.82c.234.239.614.239.849 0l7.612-7.775a.622.622 0 000-.867z","fill":"#4B62C1"}})])
          )
        }
      }
    